import { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import api from '../../services/api';
import ApolloAuth from '../../services/apolloAuth';
import Notification from '../../components/Notification';
import Input from '../../components/Input';
import Button from '../../components/Button';
import LoginBackground from '../../assets/images/login-background.png';
import LogoSvg from '../../assets/svg/logo.svg';

import {
  Container,
  Image,
  BlueEllipse,
  LoginContainer,
  Logo,
  ForgotPasswordLink,
} from './styles';

const Login = () => {
  const formRef = useRef();
  const { signIn } = useAuth();
  const [isLoading, setLoading] = useState(false);

  function getErrorMessage(err, fallback) {
    return (
      err.response?.data?.error ||
      err.response?.data?.message ||
      err.response?.data?.errors?.[0]?.message ||
      fallback
    );
  }

  // A Apolo autentica; o perfil (tipo, nome, imagem) continua vindo da API do
  // portal, que aceita o mesmo token.
  async function getProfile(token) {
    const { data } = await api.get('/user', {
      headers: { Authorization: `Bearer ${token}` },
      skipUnauthorizedRedirect: true,
    });

    return data;
  }

  async function handleFormSubmit({ email, password }) {
    formRef.current.setErrors({});
    if (email === '') {
      formRef.current.setErrors({ email: 'Informe um email' });
      return;
    }
    if (password === '') {
      formRef.current.setErrors({ password: 'Informe uma senha' });
      return;
    }

    try {
      setLoading(true);
      const session = await ApolloAuth.login({ email, password });
      const profile = await getProfile(session.token);

      if (profile.type?.toLowerCase() !== 'admin') {
        Notification({
          message: 'Acesso negado.',
          type: Notification.types.ERROR,
        });
        return;
      }

      signIn({
        newToken: session.token,
        newRefreshToken: session.refreshToken,
        newUserImage: profile.image?.url || '',
        newUserName: profile.name,
      });
    } catch (err) {
      Notification({
        message: getErrorMessage(err, 'Acesso negado'),
        type: Notification.types.ERROR,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {isLoading && <div className="loader" />}
      <Container>
        <LoginContainer>
          <Logo src={LogoSvg} alt="Logo" />
          <Form ref={formRef} onSubmit={handleFormSubmit}>
            <Input type="email" name="email" label="E-mail" />
            <Input type="password" name="password" label="Senha" />
            <Button primary text="Acessar conta" type="submit" />
          </Form>
          <ForgotPasswordLink as={Link} to="/forgot-password">
            Esqueci minha senha
          </ForgotPasswordLink>
        </LoginContainer>
        <BlueEllipse />
        <Image src={LoginBackground} />
      </Container>
    </>
  );
};

export default Login;
